// Higher number = more zoom
const scaleAmount = 0.25;
// Starting scale
const scaleBase = 1;
const viewportHeight = window.innerHeight;
const scrollBuffer = viewportHeight * scaleAmount;

const observerConfig = {
  rootMargin: "0% 0% 0% 0%",
  threshold: 0,
};

/*
 * Calculates the "percentage seen" based on when the element first enters
 * the screen until the moment it leaves
 */
const percentageSeen = ($element: HTMLElement): number => {
  if (!$element.parentNode) {
    return 0;
  }

  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;

  const parentNode = $element.parentNode;
  if (!(parentNode instanceof HTMLElement)) {
    return 0;
  }

  const { top } = parentNode.getBoundingClientRect();
  const elPosY = top + scrollY;
  const borderHeight
    = parseFloat(
      getComputedStyle(parentNode).getPropertyValue("border-bottom-width")
    )
    + parseFloat(getComputedStyle($element).getPropertyValue("border-top-width"));
  const elHeight = parentNode.offsetHeight + borderHeight;

  // If we haven't reached the element yet
  if (elPosY > scrollY + viewportHeight) {
    return 0;
  }

  // If we've completely scrolled past
  if (scrollY > elPosY + elHeight + scrollBuffer) {
    return 100;
  }

  // When the element is in the viewport
  const distance = scrollY + viewportHeight - elPosY - scrollBuffer;

  return Math.round(distance / ((viewportHeight + elHeight) / 100));
};

const instance = (element: Element) => {
  const $element = element as HTMLElement;
  const scaleAmountPercentage = scaleAmount / 100;
  let isVisible = false;
  const observer = new IntersectionObserver((elements) => {
    elements.forEach((element) => {
      isVisible = element.isIntersecting;
    });
  }, observerConfig);

  observer.observe($element);

  // Set initial scale on page load
  $element.style.scale = `${
    scaleBase + scaleAmountPercentage * percentageSeen($element)
  }`;

  // Only fires if IntersectionObserver is intersecting
  window.addEventListener("scroll", () => {
    if (isVisible) {
      $element.style.scale = `${
        scaleBase + scaleAmountPercentage * percentageSeen($element)
      }`;
    }
  });
};

export default () => {
  const $elements = document.querySelectorAll(".js-scale-on-scroll");

  $elements.forEach((element) => {
    instance(element);
  });
};
